import { Map, OrderedMap, fromJS, Map as ImmutableMap } from 'immutable';
import isEmpty from 'lodash/isEmpty';

import { camelCaseKeys } from 'Shared/utils/camelCaseKeys';

import MeetingTranscriptionsConstants from 'Shared/constants/MeetingTranscriptions.constants';
import type { AnyAction } from 'redux';
import { BotAttributes } from 'Shared/types/MeetingTranscriptions.type';

export interface MeetingTranscriptionsState extends ImmutableMap<string, any> {
  WORKSPACE_BOTS: OrderedMap<string, BotAttributes>;
}

const initialState: MeetingTranscriptionsState = Map({
  [MeetingTranscriptionsConstants.State.WORKSPACE_BOTS]: OrderedMap(),
}) as MeetingTranscriptionsState;

export const MeetingTranscriptionsReducer = (
  state: MeetingTranscriptionsState = initialState,
  action: AnyAction
): MeetingTranscriptionsState => {
  switch (action.type) {
    case MeetingTranscriptionsConstants.Actions.INVITE_BOT_SUCCESS:
    case MeetingTranscriptionsConstants.Actions.FETCH_BOT_SUCCESS:
    case MeetingTranscriptionsConstants.Actions.FETCH_BOTS_SUCCESS:
    case MeetingTranscriptionsConstants.Actions.FETCH_MEETING_TRANSCRIPTION_SUCCESS:
    case MeetingTranscriptionsConstants.Actions.ACTION_CABLE_BOT_ADDED_SUCCESS:
    case MeetingTranscriptionsConstants.Actions.ACTION_CABLE_ACTION_ITEM_ADDED_SUCCESS:
    case MeetingTranscriptionsConstants.Actions.ACTION_CABLE_SUMMARY_GENERATED_SUCCESS:
    case MeetingTranscriptionsConstants.Actions.REMOVE_BOT_SUCCESS:
    case MeetingTranscriptionsConstants.Actions.ACTION_CABLE_BOT_REMOVED_SUCCESS:
    case MeetingTranscriptionsConstants.Actions.UPDATE_DISMISS_MEETING_SUMMARY_SUCCESS:
      // is there is no data, json-api-normalizr will convert payload to
      // an empty object, we need to ensure it's not empty before trying to iterate over items
      if (isEmpty(action.payload)) {
        return state;
      }
      return state.updateIn(
        [MeetingTranscriptionsConstants.State.WORKSPACE_BOTS],
        (existing: OrderedMap<string, any> = OrderedMap()) =>
          existing.merge(
            OrderedMap(
              Object.values(action.payload.meetingTranscription).map((item: any) => [
                item.attributes.recallBotId,
                Map(fromJS(item.attributes)),
              ])
            )
          )
      );

    case 'WORKSPACE_GET_RESPONSE': {
      // Handle lastMeetingTranscription from workspace load
      const { lastMeetingTranscription } = action.data || {};
      if (lastMeetingTranscription?.recallBotId) {
        return state.updateIn(
          [MeetingTranscriptionsConstants.State.WORKSPACE_BOTS],
          (existing: OrderedMap<string, any> = OrderedMap()) =>
            existing.merge(
              OrderedMap([[lastMeetingTranscription.recallBotId, Map(fromJS(camelCaseKeys(lastMeetingTranscription)))]])
            )
        );
      }
      return state;
    }
    default:
      return state;
  }
};
